import Axios from "axios";
import * as CryptoJS from "crypto-js";
import { getParentLocation } from "./utils/helpers";

const config = {
  "https://api-internalsupport.wolkenservicedesk.com": {
    domains: ["https://internalsupport.wolkenservicedesk.com"],
  },
  "https://api-skyworks-sandbox.wolkenservicedesk.com": {
    domains: ["https://skyworkssandbox.wolkenservicedesk.com"],
  },
  "https://api-wolken-itsm-demo.wolkenservicedesk.com": {
    domains: [
      "https://wolken-itsm-demo.wolkenservicedesk.com",
      "https://wolken-csm-demo.wolkenservicedesk.com",
    ],
  },
  "https://api-sandbox1-broadcomcms-software.wolkenservicedesk.com": {
    domains: [
      "https://sandbox1-broadcomcms-software-agent.wolkenservicedesk.com",
    ],
  },
  "https://api-itsm-demo.wolkenservicedesk.com": {
    domains: [
      "https://brcmitsmsandbox.wolkenservicedesk.com",
      "https://supportstaging.wolkenservicedesk.com",
    ],
  },
};

function encryptJWT() {
  const header = {
    alg: "HS512",
    typ: "JWT",
  };
  let data = {
    sub: {
      auth: window.location.host,
    },
  };
  const secret = window.location.host;
  data["sub"] = JSON.stringify(data.sub);
  return createJWT(header, data, secret);
}

function base64Url(source) {
  return CryptoJS.enc.Base64.stringify(source)
    .replace(/=+$/, "")
    .replace(/\|+/g, "-")
    .replace(/\//g, "_");
}

function createJWT(header, data, secret = "test") {
  let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  let encodedHeader = base64Url(stringifiedHeader);
  let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  let encodedeData = base64Url(stringifiedData);
  let token = encodedHeader + "." + encodedeData;
  let signature = CryptoJS.HmacSHA512(token, secret);
  signature = base64Url(signature);
  return encodedHeader + "." + encodedeData + "." + signature;
}

var companyDetails = null;
var BASE_API_URL = null;
var userDetails = null;
export const getDomainDetails = Axios.get(
  `${process.env.REACT_APP_WMASTER_URL}/company/getDomainSsoDetails`,
  {
    headers: {
      Authorization: encryptJWT(),
    },
  }
).catch((err) => {
  console.log(err);
});

export const updateCompanyDetails = (companyDetails) => {
  companyDetails = companyDetails;
  BASE_API_URL = companyDetails.baseUrl;
  const userDetailsPromise = Axios.get(
    `${BASE_API_URL}/user/get_user_basic_details?userId=`,
    {
      headers: {
        domain: new URL(document.referrer).hostname,
      },
      withCredentials: true,
    }
  ).catch((err) => {
    console.log(err);
  });

  userDetailsPromise.then((response) => {
    if (response?.data?.data?.user) {
      userDetails = response.data.data.user;
    }
  });
};

// export const getApiBaseUrl = () => {
//   const domainLocation = getParentLocation()?.origin;
//   window.localStorage.removeItem("view");
//   console.log("domainLocation", domainLocation);
//   if (!domainLocation || domainLocation.includes("127.0.0.1")) {
//     window.localStorage.setItem(
//       "view",
//       JSON.stringify({ unique_id: "conductor-iframe" })
//     );

//     return "https://api-skyworks-sandbox.wolkenservicedesk.com";
//   }
//   for (const key in config) {
//     if (config[key].domains.includes(domainLocation)) {
//       return key;
//     }
//   }
// };

// export const getApiBaseUrl = () => {
//   const domainLocation = getParentLocation()?.origin;
//   if(domainLocation.includes("localhost")) {
//     return "https://api-itsm-demo.wolkenservicedesk.com/";
//   } else if(BASE_API_URL){
//     return BASE_API_URL;
//   }
//   else{
//     if(companyDetails){
//       BASE_API_URL=companyDetails.baseUrl;
//       return BASE_API_URL;
//     }
//     return null;
//   }
// };

export const getApiBaseUrl = () => {
  const domainLocation = getParentLocation()?.origin;
  // return "https://api-itsm-demo.wolkenservicedesk.com/";


  if (domainLocation.includes("localhost")) {
   
    return "https://api-itsm-demo.wolkenservicedesk.com/";
  } else if (BASE_API_URL) {
   
    return BASE_API_URL;
  } else {
    if (companyDetails) {
      BASE_API_URL = companyDetails.baseUrl;
      
      return BASE_API_URL;
    }
    return null;
  }
};

export const getUserDetails = () => {
  return userDetails ? userDetails : { userEmail: "example@localhost.com" };
};
